import Vue from 'vue';
import Router from 'vue-router';

import Startpage from '@/views/startpage.vue';
import Profile from '@/views/profile.vue';
import ProjectView from '@/views/project.vue';

Vue.use(Router);

export default new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Startpage,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/project/:projectId',
      name: 'project',
      component: ProjectView,
      props: true,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: '/me',
      name: 'profile',
      component: Profile,
      meta: {
        requireAuth: true,
      },
    },
  ],
});
